// Curash product reviews — premium "What our customers say" carousel.
// A fixed pool of 50 reviews is shuffled deterministically per product (seeded
// by product id) so each product shows a different order, consistent on reload.
// Desktop: 4 per view; mobile: 1 per view. Swipe + arrows + dots.
(function () {
  'use strict';

  var POOL = [
    { n: 'Sofia R.',     r: 5, t: 'Snatched in all the right places', b: 'Honestly the best shapewear I have owned. Smooths everything and you genuinely forget you are wearing it.' },
    { n: 'Amara K.',     r: 5, t: 'Worth every penny',                b: 'The fabric feels luxe, not cheap and squeezy like others. Held me in through a 10-hour event with zero rolling.' },
    { n: 'Emily T.',     r: 4, t: 'Beautiful fit',                    b: 'Gorgeous under a slip dress. Took half a size up from my usual and it was perfect. Would buy again.' },
    { n: 'Priya S.',     r: 5, t: 'Confidence in a piece',           b: 'I felt so put together. The seams are invisible under everything and it never dug in.' },
    { n: 'Jade M.',      r: 5, t: 'Finally something that stays put', b: 'No more constant adjusting. It stayed exactly where it should all day. Obsessed.' },
    { n: 'Hannah L.',    r: 4, t: 'Lovely quality',                   b: 'Soft, supportive and the stitching is clearly premium. Knocked one star only because I wanted it a touch longer.' },
    { n: 'Olivia B.',    r: 5, t: 'My new everyday',                  b: 'Bought one, came back for three. Comfortable enough to live in and the shaping is so flattering.' },
    { n: 'Mei C.',       r: 5, t: 'Sculpts without squeezing',       b: 'Smooth silhouette but I could still breathe and eat dinner. That balance is rare.' },
    { n: 'Grace W.',     r: 5, t: 'Photos do not do it justice',     b: 'Even better in person. The material is thick in the right way and the colour is rich.' },
    { n: 'Layla F.',     r: 4, t: 'Great for my shape',              b: 'Gave me a lovely hourglass line under a fitted dress. Sizing runs slightly small so size up.' },
    { n: 'Isabel N.',    r: 5, t: 'Invisible under everything',      b: 'No VPL, no lines, nothing. Looks like a second skin and feels like one too.' },
    { n: 'Chloe D.',     r: 5, t: 'Premium feel',                    b: 'You can feel the quality the second you put it on. Worth the upgrade from the cheap ones I had.' },
    { n: 'Nadia H.',     r: 5, t: 'Held me through a wedding',       b: 'Danced all night, no rolling down, no digging in. I was honestly shocked at how comfortable it was.' },
    { n: 'Rachel P.',    r: 4, t: 'Really impressed',                b: 'Smoothing is excellent and the fabric breathes. Wish there were more colours but the fit is spot on.' },
    { n: 'Tara V.',      r: 5, t: 'A wardrobe essential',            b: 'Wear it under almost everything now. Gives the cleanest line and lasts wash after wash.' },
    { n: 'Bianca G.',    r: 5, t: 'So flattering',                   b: 'Took inches off my silhouette without flattening me. Looks natural, not compressed.' },
    { n: 'Sara A.',      r: 5, t: 'Comfortable all day',             b: 'Wore it to work and completely forgot about it. No pinching, no rolling. Buying more.' },
    { n: 'Maya J.',      r: 4, t: 'Lovely under dresses',            b: 'Perfect for slinky fabrics. Slightly snug on the straps for me but the body fit is beautiful.' },
    { n: 'Lucia M.',     r: 5, t: 'Better than the big brands',      b: 'Tried the famous ones and this beats them on comfort and quality. Will not go back.' },
    { n: 'Aisha B.',     r: 5, t: 'Holds everything in',            b: 'Smooth from every angle. The waist control is exactly what I was after and it stays in place.' },
    { n: 'Daniela R.',   r: 5, t: 'Soft and strong',               b: 'Surprisingly soft for how much support it gives. The seams never irritate my skin.' },
    { n: 'Freya S.',     r: 4, t: 'Good value for quality',         b: 'Feels far more expensive than it was. Took a couple of wears to mould to me, then perfect.' },
    { n: 'Noor K.',      r: 5, t: 'Game changer',                   b: 'Completely changed how my clothes sit. I look polished in everything now.' },
    { n: 'Camila T.',    r: 5, t: 'Stays in place',                 b: 'No constant pulling down. Whatever they did to the band, it works. Comfortable for hours.' },
    { n: 'Zoe H.',       r: 5, t: 'Gorgeous and supportive',       b: 'Pretty enough that I do not mind it showing, and the support is genuinely impressive.' },
    { n: 'Ines P.',      r: 4, t: 'Really nice',                    b: 'Lovely smoothing effect under my work dresses. Would love a longer length option too.' },
    { n: 'Yara M.',      r: 5, t: 'Obsessed',                       b: 'Bought for one event, now I reach for it weekly. The fit is just that good.' },
    { n: 'Leah C.',      r: 5, t: 'Premium all the way',            b: 'From the packaging to the fabric, it feels high end. Smoothing is flawless.' },
    { n: 'Marta D.',     r: 5, t: 'Best purchase this year',        b: 'I keep recommending it to friends. Comfortable, flattering and well made.' },
    { n: 'Selin A.',     r: 4, t: 'Flatters my curves',             b: 'Gives shape without squashing. Sizing was accurate for me once I checked the chart.' },
    { n: 'Paula G.',     r: 5, t: 'Feels like nothing',             b: 'The most comfortable shaping piece I have tried. Forgot I had it on by lunchtime.' },
    { n: 'Hana T.',      r: 5, t: 'Smooth and seamless',            b: 'Zero lines under a clingy dress. Looks like I am wearing nothing underneath.' },
    { n: 'Renee B.',     r: 5, t: 'Quality you can feel',           b: 'Thick, supportive, beautifully finished. You can tell it will last.' },
    { n: 'Alina K.',     r: 4, t: 'Great everyday piece',           b: 'Comfortable enough to wear daily. A touch firm at first but loosens to a perfect fit.' },
    { n: 'Bella S.',     r: 5, t: 'Stunning silhouette',            b: 'Gave me the cleanest line under my gown. Got so many compliments on how I looked.' },
    { n: 'Carmen V.',    r: 5, t: 'Holds up wash after wash',       b: 'No stretching out, no pilling. Still feels new after months of wear.' },
    { n: 'Dina F.',      r: 5, t: 'So comfortable',                 b: 'Soft on the skin and supportive where it counts. My new go-to under everything.' },
    { n: 'Esra N.',      r: 4, t: 'Lovely fit',                     b: 'Really flattering and well made. Just size up if you are between sizes.' },
    { n: 'Farah J.',     r: 5, t: 'Worth the hype',                 b: 'Skeptical at first but it lives up to it. Smoothing and comfort are both excellent.' },
    { n: 'Gina R.',      r: 5, t: 'Snug in the best way',           b: 'Supportive without cutting in. I feel held and confident wearing it.' },
    { n: 'Halle M.',     r: 5, t: 'Flawless under fabric',          b: 'My dresses sit so much better now. No bumps, no lines, just smooth.' },
    { n: 'Iris D.',      r: 4, t: 'Pleasantly surprised',           b: 'Better quality than expected for the price. Comfortable and very flattering.' },
    { n: 'Jana P.',      r: 5, t: 'Repeat customer',                b: 'On my third one now. Consistent quality and the fit never disappoints.' },
    { n: 'Kira B.',      r: 5, t: 'Beautifully made',               b: 'The finishing details are lovely and it feels expensive. Smooths everything out.' },
    { n: 'Lena S.',      r: 5, t: 'My confidence booster',          b: 'I stand taller wearing it. Genuinely makes my outfits look more polished.' },
    { n: 'Nina T.',      r: 4, t: 'Really good',                    b: 'Comfortable and effective. Would give five stars with a slightly softer waistband.' },
    { n: 'Oksana V.',    r: 5, t: 'Cannot fault it',               b: 'Fit, comfort and quality all spot on. Exactly what premium shapewear should be.' },
    { n: 'Petra G.',     r: 5, t: 'Love love love',                b: 'Wearing it under my favourite dress right now and I feel amazing. Highly recommend.' },
    { n: 'Rosa M.',      r: 5, t: 'Sleek and supportive',          b: 'Gives a smooth, sculpted look with zero discomfort. Stays put all evening.' },
    { n: 'Sana K.',      r: 5, t: 'Exceeded expectations',          b: 'Soft, strong and seamless. The kind of piece you end up buying in every colour.' }
  ];

  // ---- Deterministic seeded RNG (mulberry32) so shuffle is stable per product.
  function mulberry32(a) {
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  function seededShuffle(arr, seed) {
    var a = arr.slice();
    var rng = mulberry32(seed >>> 0 || 1);
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rng() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  // Spread review dates over the last ~7 months, deterministic per review index.
  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function reviewDate(seed, idx) {
    var rng = mulberry32(((seed >>> 0) + idx * 2654435761) >>> 0);
    var now = new Date();
    var daysBack = 5 + Math.floor(rng() * 210);
    var d = new Date(now.getTime() - daysBack * 86400000);
    return MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  function starsHtml(r) {
    var pct = (r / 5) * 100;
    return '<span class="curash-reviews__card-stars" aria-label="' + r + ' out of 5">'
      + '<span class="curash-reviews__stars-bg" aria-hidden="true">★★★★★</span>'
      + '<span class="curash-reviews__stars-fg" style="width:' + pct + '%" aria-hidden="true">★★★★★</span>'
      + '</span>';
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHtml(rev, seed, idx) {
    var initial = rev.n.charAt(0).toUpperCase();
    return '<article class="curash-reviews__card">'
      + '<div class="curash-reviews__card-top">'
      +   '<span class="curash-reviews__avatar" aria-hidden="true">' + initial + '</span>'
      +   '<div class="curash-reviews__card-meta">'
      +     '<span class="curash-reviews__card-name">' + escapeHtml(rev.n) + '</span>'
      +     '<span class="curash-reviews__verified"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7"/></svg>Verified Purchase</span>'
      +   '</div>'
      + '</div>'
      + starsHtml(rev.r)
      + '<h3 class="curash-reviews__card-title">' + escapeHtml(rev.t) + '</h3>'
      + '<p class="curash-reviews__card-body">' + escapeHtml(rev.b) + '</p>'
      + '<span class="curash-reviews__card-date">' + reviewDate(seed, idx) + '</span>'
      + '</article>';
  }

  function initSection(section) {
    if (section.dataset.reviewsWired === '1') return;
    section.dataset.reviewsWired = '1';

    var seed = parseInt(section.getAttribute('data-seed'), 10) || 1;
    var track = section.querySelector('[data-reviews-track]');
    var viewport = section.querySelector('[data-reviews-viewport]');
    var prevBtn = section.querySelector('[data-reviews-prev]');
    var nextBtn = section.querySelector('[data-reviews-next]');
    var dotsWrap = section.querySelector('[data-reviews-dots]');
    if (!track || !viewport) return;

    // Shuffle the whole pool per product, then show a generous slice (24) so
    // there is plenty to swipe through without it being endless.
    var ordered = seededShuffle(POOL, seed).slice(0, 24);
    track.innerHTML = ordered.map(function (rev, i) { return cardHtml(rev, seed, i); }).join('');

    var cards = Array.prototype.slice.call(track.children);
    var index = 0;

    function perView() { return window.matchMedia('(max-width: 749px)').matches ? 1 : 4; }
    function maxIndex() { return Math.max(0, cards.length - perView()); }

    function update() {
      if (!cards.length) return;
      if (index > maxIndex()) index = maxIndex();
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      var cardW = cards[0].getBoundingClientRect().width;
      track.style.transform = 'translateX(' + (-(index * (cardW + gap))) + 'px)';
      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= maxIndex();
      renderDots();
    }

    function renderDots() {
      if (!dotsWrap) return;
      var pages = maxIndex() + 1;
      if (pages <= 1) { dotsWrap.innerHTML = ''; return; }
      var html = '';
      for (var p = 0; p < pages; p++) {
        html += '<button type="button" class="curash-reviews__dot' + (p === index ? ' is-active' : '') + '" data-dot="' + p + '" aria-label="Go to review page ' + (p + 1) + '"></button>';
      }
      dotsWrap.innerHTML = html;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { index = Math.max(0, index - perView()); update(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { index = Math.min(maxIndex(), index + perView()); update(); });
    if (dotsWrap) dotsWrap.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-dot]');
      if (!dot) return;
      index = Math.min(maxIndex(), parseInt(dot.getAttribute('data-dot'), 10) || 0);
      update();
    });

    // Touch swipe.
    var startX = 0, dragging = false;
    viewport.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; dragging = true; }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (!dragging) return; dragging = false;
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) index = Math.min(maxIndex(), index + perView());
        else index = Math.max(0, index - perView());
        update();
      }
    }, { passive: true });

    var rt;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(update, 150); });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-curash-reviews]').forEach(initSection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
